import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

import { timeStringFormat } from '@/common/lib/timer';

import css from './styles.module.scss';

const timerVariants = cva('', {
  variants: {
    variant: {
      'grey-bordered': css.greyBordered,
    },
  },
});

interface TimerProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof timerVariants> {
  seconds: number;
  template?: string;
}

const Timer = forwardRef<HTMLDivElement, TimerProps>(
  ({ variant, seconds, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cn(props.className, timerVariants({ variant }), 'font-bold')}
      >
        {timeStringFormat(seconds * 1000, { template: props.template })}
      </div>
    );
  },
);

export { Timer };
